import {Component, ElementRef, EventEmitter, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {RfqDataService} from '../service/rfq.data.service';
import {NgForm} from '@angular/forms';
import {Message} from 'primeng/api';

@Component({
    selector: 'app-rfq-step-two',
    templateUrl: './step-two.component.html',
    styleUrls: ['../rfq.component.scss', '../rfq.blocks.scss']
})
export class StepTwoComponent implements OnInit {

    @Input('event') event$: EventEmitter<boolean>;
    @Input('navigation$') navigation$: EventEmitter<boolean>;

    @ViewChild('stepTwo', {static: false}) stepTwoDivElement!: ElementRef<HTMLDivElement>;
    @ViewChild('navigation') navigation!: ElementRef<HTMLDivElement>;
    @ViewChild('propertyComponentForm') propertyComponentForm: NgForm;

    errors: Message[] = [{severity: 'error', detail: 'Please correct errors on the indicated fields.'}];
    uuid: string;

    householdSizeOptions: any[] = [
        {label: '1 - 2', value: '1-2'},
        {label: '3 - 4', value: '3-4'},
        {label: '5+', value: '5+'}
    ];

    storeyOptions: any[] = [
        {label: 'Single', value: 'Single'},
        {label: 'Multi-Storey', value: 'Multi'}
    ];

    roofTypeOptions: any[] = [
        {label: 'Corrugated', value: 'Corrugated'},
        {label: 'Tile', value: 'Tile'},
        {label: 'Thatch', value: 'Thatch'},
        {label: 'Other', value: 'Other'}
    ];

    roofDirectionOptions: any[] = [
        {label: 'North', value: 'North'},
        {label: 'East', value: 'East'},
        {label: 'South', value: 'South'},
        {label: 'West', value: 'West'}
    ];

    panelsToInverterOptions: any[] = [
        {label: '< 10m', value: '10'},
        {label: '< 20m', value: '20'},
        {label: '< 30m', value: '30'},
        {label: '< 40m', value: '40'},
        {label: '40+ m', value: '50'}
    ];

    inverterToDbOptions: any[] = [
        {label: '< 10m', value: '10'},
        {label: '< 20m', value: '20'},
        {label: '< 30m', value: '30'},
        {label: '< 40m', value: '40'},
        {label: '40+ m', value: '50'}
    ];

    constructor(@Inject(DOCUMENT) public document: Document,
                public data: RfqDataService) {
    }

    ngOnInit(): void {
        this.event$?.subscribe((event: boolean): void => {
            this.data.steps[1].height
                = this.navigation.nativeElement.scrollHeight + this.stepTwoDivElement.nativeElement.scrollHeight;
        });
    }

    ngModelChanged($event?: any): void {}

    back(): void {
        this.navigation$.emit(false);
    }

    next(): void {
        this.navigation$.emit(true);
    }
}
